
import axios from 'axios';
import { navigateToLoginPage } from './components/withAuth';

//====================================================
function readCookie(name) {
    if (typeof document !== 'undefined') {
        //function split cookie for get csrf token
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
}
const CSRFTOKEN = readCookie('csrftoken'); //get csrftoken
//======================================================

export async function deletePlan(data) {
  try {
    const config = {
      method: 'DELETE',
      headers: {
        'X-CSRFToken': CSRFTOKEN,
        'content-type': 'application/json',
      },
      body: JSON.stringify(data),
    };
    const response = await fetch('/api/delete/', config);
    return await response.json();
  } catch (error) {
    navigateToLoginPage();
  }
}

export async function undeletePlan( data ) {
    const config = {
        method: 'POST',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/undelete/', config);
    return await response.json();
}

export async function updateNewPlan( data ){
    const config = {
        method: 'PUT',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
        body: JSON.stringify(data)
    }
    const response = await fetch('/api/ifloorplans/'+data.id+'/', config);
    return await response.json();
}


export async function patchNewPlan( data ){
    try {
      const config = {
        method: 'PATCH',
        headers: {
          'X-CSRFToken': CSRFTOKEN,
          'content-type': 'application/json',
        },
        body: JSON.stringify(data),
      };
      const response = await fetch('/api/ifloorplans/' + data.id + '/', config);
      if (response.status === 200) return await response.json();
      else navigateToLoginPage();
    } catch (error) {
      console.log('🚀 | file: requests.js | line 77 | error', error);
    }
}

export async function getTemplates( data ){
    const config = {
        method: 'GET',
        headers: {
            "X-CSRFToken": CSRFTOKEN,
            'content-type': 'application/json'
        },
    }
    const response = await fetch('/api/ifloorplans/', config);
    return await response.json();
}
